import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import anime from 'animejs/lib/anime.es.js';
import { useLanguage } from '../contexts/LanguageContext';

const VVS_LOGO = 'https://customer-assets.emergentagent.com/job_ac09e30e-ff84-4be5-9a8e-38b36c255d06/artifacts/yqc71nna_FromNow2.jpg';

export default function FairflowPage() {
  const { t } = useLanguage();
  const heroRef = useRef(null);

  useEffect(() => {
    document.title = 'Fairflow // VVS';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !heroRef.current) return;

    anime.timeline({ easing: 'easeOutExpo' })
      .add({ targets: '.ff-label', translateY: [20, 0], opacity: [0, 1], duration: 700 })
      .add({ targets: '.ff-title', translateY: [50, 0], opacity: [0, 1], duration: 1000 }, '-=400')
      .add({ targets: '.ff-body', translateY: [20, 0], opacity: [0, 1], duration: 700 }, '-=500')
      .add({ targets: '.ff-cta', scale: [0.95, 1], opacity: [0, 1], duration: 500 }, '-=300');
  }, []);

  return (
    <div style={{ position: 'relative', zIndex: 1, paddingTop: '64px', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <section ref={heroRef} style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        justifyContent: 'center', alignItems: 'center', textAlign: 'center',
        padding: '100px 48px', position: 'relative', overflow: 'hidden',
      }} data-testid="fairflow-page">
        <div style={{ position: 'absolute', top: '80px', left: '50%', transform: 'translateX(-50%)', width: '1px', height: '60px', background: 'linear-gradient(to bottom, transparent, rgba(212,175,55,0.3))' }} />

        <p className="ff-label caption" style={{ color: 'rgba(212,175,55,0.55)', marginBottom: '24px', letterSpacing: '0.3em', opacity: 0 }}>
          {t('fairflow.label')}
        </p>

        <h1 className="ff-title" style={{
          fontFamily: 'Syne, sans-serif', fontWeight: 800,
          fontSize: 'clamp(36px, 7vw, 80px)',
          lineHeight: 1, letterSpacing: '-0.02em', textTransform: 'uppercase',
          color: '#F0F4F8', marginBottom: '32px', opacity: 0,
        }}>
          {t('fairflow.title1')}
        </h1>

        <p className="ff-body" style={{
          fontFamily: 'Space Grotesk', fontSize: 'clamp(13px, 1.8vw, 17px)',
          lineHeight: 1.85, color: 'var(--vvs-muted)', maxWidth: '560px',
          marginBottom: '20px', opacity: 0,
        }}>
          {t('fairflow.body')}
        </p>

        <p className="ff-body" style={{
          fontFamily: 'Space Grotesk', fontSize: '12px',
          color: 'rgba(148,163,184,0.4)', maxWidth: '400px',
          marginBottom: '48px', opacity: 0, letterSpacing: '0.04em',
        }}>
          {t('fairflow.coming')}
        </p>

        <div className="ff-cta" style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', justifyContent: 'center', opacity: 0 }}>
          <Link to="/" className="btn-metallic" data-testid="fairflow-back-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>
            {t('fairflow.back')}
          </Link>
          <a href="https://fairflow.be"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-metallic" data-testid="fairflow-open-btn"
            style={{ textDecoration: 'none', display: 'inline-block', borderColor: 'rgba(212,175,55,0.25)', color: 'rgba(212,175,55,0.65)' }}>
            {t('fairflow.interest')}
          </a>
        </div>

        <div style={{ position: 'absolute', bottom: '80px', left: '50%', transform: 'translateX(-50%)', width: '1px', height: '60px', background: 'linear-gradient(to top, transparent, rgba(212,175,55,0.3))' }} />
      </section>

      <div style={{ padding: '24px 48px', textAlign: 'center', borderTop: '1px solid rgba(240,244,248,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
          <img src={VVS_LOGO} alt="VVS" style={{ width: '22px', height: '22px', objectFit: 'cover', borderRadius: '50%', opacity: 0.55 }} />
          <Link to="/" style={{ fontFamily: 'Space Grotesk', fontSize: '10px', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--vvs-subtle)', textDecoration: 'none' }}>
            {t('fairflow.project')}
          </Link>
        </div>
      </div>
    </div>
  );
}
